import { useContext } from 'react';
import GlobalContext from '~/context/vdp/GlobalContext';
import SpinnerContext from '~/context/vdp/SpinnerContext';
import { useGetIsWIPVehicle } from '~/context/vdp/VehicleContext';

export default function useGetShouldRenderBelowSpinner() {
  const isWip = useGetIsWIPVehicle();
  const { isLazyLoadEnabled } = useContext(GlobalContext);
  const { hasError, isSpinnerScriptInserted, isSpinnerDisabled } =
    useContext(SpinnerContext);

  return (
    !isLazyLoadEnabled ||
    isWip ||
    hasError ||
    isSpinnerScriptInserted ||
    isSpinnerDisabled
  );
}
